/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-root{display:block;width:100%;height:100%}app-root .be-container,app-root .container{margin:0 auto;padding-left:15px;padding-right:15px}@media screen and (min-width:768px){app-root .be-container,app-root .container{max-width:750px}}@media screen and (min-width:992px){app-root .be-container,app-root .container{max-width:970px}}@media screen and (min-width:1200px){app-root .be-container,app-root .container{max-width:1170px}}"];
export { styles as styles };
